export default function auth(state = true, action) {
  switch(action.type) {
    case 'change_auth': 
      state =  action.current;
      return state;
    default: 
      return state;
  }
};
